import React, { Component } from 'react';
import PropTypes from "prop-types";

import { withTranslation } from 'react-i18next';

class WebNetCameraParms extends Component {
     
    state = { 
        loading: true,
        disableDiv: false,
    };

    async componentDidMount() {
        const { params_jdoc, } = this.props;
        if (params_jdoc != undefined) {
            //console.log(params_jdoc);
            if (params_jdoc.camerapararameters.length > 0) {
                this.setState({ loading: false, disableDiv: true });
            } else {
                this.setState({ divStyle: false });
            }
        } else {
            this.setState({ divStyle: false });
        }
    }

    static fillParamsList (params, t) {

        const res = JSON.parse(params.camerapararameters[0].params_jdoc);

        var param = {};
        let arrParams = [];
        let RangeMax = "";

        for (const key in res) {

            if (key == "Camera") {
                const camParams = res[key];
                for (const paramI in camParams) {
                    if (paramI !== "MAC") { 
                        if (paramI == "RangeMax") {
                            RangeMax = camParams[paramI];
                        } else if (paramI == "RangeMin") {
                            param.label = t("Measurement range") + ":";
                            param.value = camParams[paramI].toFixed(2) + " - " + RangeMax.toFixed(2);
                            arrParams.push({ ...param });
                        } else if (paramI == "SerialNumber") {
                            param.label = t("Serial number") + ":" ;
                            param.value = camParams[paramI]
                            arrParams.push({ ...param });
                        } else { 
                            param.label = t(paramI) + ":";
                            param.value = camParams[paramI];
                            arrParams.push({ ...param });
                        }
                    }
                }
            } else {
                if (key == "RelativeHumidity")
                    param.label = t("Relative humidity") + ":"
                else if (key == "ExternalOpticsTemperature")
                    param.label = t("External optics temperature") + ":"
                else if (key == "ExternalOpticsTransmission")
                    param.label = t("External optics transmission") + ":"
                else
                  param.label = t(key) +":";

                if (["Emissivity", "RelativeHumidity", "ExternalOpticsTemperature", "ExternalOpticsTransmission"].includes(key)) {
                    if (key == "ExternalOpticsTemperature") 
                        param.value = (res[key].toFixed(2) - 273.15).toString() + " " + String.fromCharCode(176) + "C" ;
                    else
                     param.value = res[key].toFixed(2);
                } else 
                    param.value = res[key];
                
                arrParams.push({ ...param });
            }
        }

        let finalParams = [];
        finalParams

        return arrParams;
}

    static renderCamParams(params, t) {

    return (
        <table className='table'>
            <thead>
                <tr>
                    <th>{t("Parameter")}</th>
                    <th>{t("Value")}</th>
                </tr>

            </thead>
            <tbody>
                {WebNetCameraParms.fillParamsList(params,t).map((cam) =>
                        <tr key={cam.label}>
                            <td> {cam.label} </td>
                            <td>{cam.value}</td>
                        </tr>
                    )}
            </tbody>
        </table>
    );
  }


  render() {
      var divStyle = {
          display: this.state.disableDiv ? 'block' : 'none'
      };

      const { params_jdoc, t } = this.props;



      let contents = "No parameters found";
      if (params_jdoc != undefined) {
          //console.log(params_jdoc.camerapararameters);
          if (params_jdoc.camerapararameters.length > 0) {
              //console.log(params_jdoc.camerapararameters.length);
              contents = WebNetCameraParms.renderCamParams(params_jdoc, t);
          }
      } 
    return (
        <div style={divStyle}>
        {contents}
      </div>
    );
  }
}

export default withTranslation()(WebNetCameraParms);

WebNetCameraParms.propTypes = {
    params_jdoc: PropTypes.object,
    
}